var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInkscapeOriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.994 0 0 .994 .389 -1.445)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.783
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3 10.088l-44.8 45.8c-16.9 16.9 11 15.5 21.1 21.9 4.7 3-15 6.9-11 11 3.9 4 23.6 7.7 27.5 11.6 3.9 4-7.9 8.2-4 12.3 3.8 4 12.9.2 14.5 9.3 1.2 6.7 16.7 3.4 23.7-2.4 4.3-3.7-7.5-3.7-3.6-7.7 9.8-9.9 18.5-4.5 22-13.6 2-4.9-14.8-8.4-10.3-11.5 10.7-7.5 49.7-11.3 31.7-29.3l-46.3-47.4c-5.8-5.4-15.2-5.4-20.5 0zm51.3 88.2c0 2.3 17.7 3.6 16.7-.5-1.4-7-14.8-6.4-16.7.5zm-75.4 12.1c4 3.5 10.1-.8 12-5.6-3.9-5.2-18.3.2-12 5.6zm73.2-7.3c-5 4.6.9 9.3 5.8 6.2 1.3-.9-.1-5.1-5.8-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.576,
    d: "M53.3 11.088l-44.8 45.8c-16.9 17 11 15.6 21.1 22 4.7 3-15 6.9-11 11 3.9 4 23.6 7.7 27.5 11.6 3.9 4-7.9 8.2-4 12.3 3.8 4 12.9.2 14.5 9.3 1.2 6.7 16.7 3.4 23.7-2.4 4.3-3.7-7.5-3.7-3.6-7.7 9.8-9.9 18.5-4.5 22-13.6 2-4.9-14.8-8.4-10.3-11.5 10.6-7.5 49.7-11.3 31.7-29.3l-46.3-47.5c-5.8-5.4-15.2-5.4-20.5 0zm51.3 88.3c0 2.3 17.7 3.6 16.7-.5-1.4-7-14.8-6.5-16.7.5zm-75.4 12c4 3.5 10.1-.8 12-5.6-3.9-5.1-18.3.3-12 5.6zm73.2-7.2c-5 4.6.9 9.3 5.8 6.2 1.3-.9-.1-5.2-5.8-6.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.3 9L8.5 54.8c-16.9 16.9 11 15.5 21.1 21.9 4.7 3-15 6.9-11 11 3.9 4 23.6 7.7 27.5 11.6 3.9 4-7.9 8.2-4 12.3 3.8 4 12.9.2 14.5 9.3 1.2 6.7 16.7 3.4 23.7-2.4 4.3-3.7-7.5-3.7-3.6-7.7 9.8-9.9 18.5-4.5 22-13.6 2-4.9-14.8-8.4-10.3-11.5 10.6-7.5 49.7-11.3 31.7-29.3L73.8 9C68 3.6 58.6 3.6 53.3 9zm51.3 88.2c0 2.3 17.7 3.6 16.7-.5-1.4-6.9-14.8-6.4-16.7.5zm-75.4 12.1c4 3.5 10.1-.8 12-5.6-3.9-5.2-18.3.3-12 5.6zm73.2-7.3c-5 4.6.9 9.3 5.8 6.2 1.3-.9-.1-5.1-5.8-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3 9L8.5 54.8c-16.9 16.9 11 15.5 21.1 21.9 4.7 3-15 6.9-11 11 3.9 4 23.6 7.7 27.5 11.6 3.9 4-7.9 8.2-4 12.3 3.8 4 12.9.2 14.5 9.3 1.2 6.7 16.7 3.4 23.7-2.4 4.3-3.7-7.5-3.7-3.6-7.7 9.8-9.9 18.5-4.5 22-13.6 2-4.9-14.8-8.4-10.3-11.5 10.6-7.5 49.7-11.3 31.7-29.3L73.8 9C68 3.6 58.6 3.6 53.3 9zm51.3 88.2c0 2.3 17.7 3.6 16.7-.5-1.4-6.9-14.8-6.4-16.7.5zm-75.4 12.1c4 3.5 10.1-.8 12-5.6-3.9-5.2-18.3.3-12 5.6zm73.2-7.3c-5 4.6.9 9.3 5.8 6.2 1.3-.9-.1-5.1-5.8-6.2z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M53.4 9.5L9.1 54.9C-7.7 71.7 19.9 70.3 29.9 76.6c4.6 3-14.8 6.9-10.9 10.9 3.9 4 23.3 7.6 27.2 11.5 3.9 4-7.8 8.2-4 12.1 3.8 4 12.8.2 14.4 9.2 1.2 6.7 16.6 3.3 23.4-2.4l-3.5-7.6c9.7-9.8 18.3-4.4 21.8-13.4 1.9-4.8-14.6-8.3-10.2-11.4 10.5-7.4 49.2-11.2 31.4-29l-45.9-47c-5.6-5.3-15-5.3-20.2 0zM42.7 79.1c1 0 33.1 4.3 20.7 7.6-4.7 1.3-26.4-7.6-20.7-7.6zm61.5 17.8c0 2.3 17.5 3.5 16.6-.5-1.4-6.9-14.7-6.3-16.6.5zm-74.7 12c4 3.4 10-.8 11.9-5.6-3.8-5.1-18.1.3-11.9 5.6zm72.6-7.2c-4.9 4.5.9 9.2 5.7 6.1 1.2-.9-.2-5.1-5.7-6.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.991 0 0 .991 .605 .604)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 98.293,
    y1: 237.026,
    x2: 74.286,
    y2: 215.319,
    gradientTransform: "matrix(.985 0 0 -.985 6.128 272.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C0CDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07092D",
    stopOpacity: 0.288
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M53.4 9.5L9.1 54.9C-7.7 71.7 19.9 70.3 29.9 76.6c4.6 3-14.8 6.9-10.9 10.9 3.9 4 23.3 7.6 27.2 11.5 3.9 4-7.8 8.2-4 12.1 3.8 4 12.8.2 14.4 9.2 1.2 6.7 16.6 3.3 23.4-2.4l-3.5-7.6c9.7-9.8 18.3-4.4 21.8-13.4 1.9-4.8-14.6-8.3-10.2-11.4 10.5-7.4 49.2-11.2 31.4-29l-45.9-47c-5.6-5.3-15-5.3-20.2 0zM42.7 79.1c1 0 33.1 4.3 20.7 7.6-4.7 1.3-26.4-7.6-20.7-7.6zm61.5 17.8c0 2.3 17.5 3.5 16.6-.5-1.4-6.9-14.7-6.3-16.6.5zm-74.7 12c4 3.4 10-.8 11.9-5.6-3.8-5.1-18.1.3-11.9 5.6zm72.6-7.2c-4.9 4.5.9 9.2 5.7 6.1 1.2-.9-.2-5.1-5.7-6.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 33.173,
    y1: 245.076,
    x2: 60.308,
    y2: 217.941,
    gradientTransform: "matrix(1.003 0 0 -1.003 -.413 276.586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.505,
    fill: "url(#d)",
    d: "M12.5 57.3C.3 69.3 21.7 66 38.1 72.4l34-59.7c-5.1-5.3-11.7-4.8-16.4 0L12.5 57.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 48.612,
    y1: 250.177,
    x2: 81.173,
    y2: 217.616,
    gradientTransform: "matrix(.994 0 0 -.994 2.709 274.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M71.1 12.3l17.7 18c1.6 1.6 1.6 5 .7 6l-8.8-7.2L79 39.6l-7.3-3.9-11.8 7.5L56 27.5l-6.3 13.7-15.9-.2c-3 0-2.6-3.1.5-6.3 6.2-6.8 18.2-18.5 22-22.5 4-4 10.8-3.8 14.8.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 51.136,
    cy: 13.518,
    r: 33.212,
    gradientTransform: "matrix(.827 0 0 -.553 1.123 126.746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.217,
    fill: "url(#f)",
    d: "M46.8 97.4s1.9 2.9 1.7 4.3c-.4 2.7-6.2 4.1-4.9 6.5 1.3 2.4 5.9 1 9.7 3.5 3.8 2.5 2.8 7.5 5.6 8.8 5.4 2.5 19.8-4.3 19-4.1-.7.1-14.1 2.9-17.1.5-3.4-2.8-4.4-4.7-7-6.4-2.4-1.5-5.7-2.2-6.5-3.4-.8-1.3 1.6-2.9 1.7-5.3.2-1.6-2.2-4.4-2.2-4.4z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.276
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 147.452,
    cy: 14.758,
    r: 33.212,
    gradientTransform: "matrix(1.055 0 0 -.706 -97.55 130.348)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M46.8 97.4s1.9 2.9 1.7 4.3c-.4 2.7-6.2 4.1-4.9 6.5 1.3 2.4 5.9 1 9.7 3.5 3.8 2.5 2.8 7.5 5.6 8.8 5.4 2.5 19.8-4.3 19-4.1-23.8.1-19.3-6-28.5-10.1-1.3-.6-.6-2.2-.4-4.6.2-1.5-2.2-4.3-2.2-4.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: -53.737,
    cy: 94.673,
    r: 37.174,
    gradientTransform: "matrix(.526 0 0 -.223 130.969 98.356)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.453,
    fill: "url(#h)",
    d: "M87.2 84.9c21.3-7.8 28.2-8.9 35.2-16C114.2 75.8 97 79.5 83 85.6l4.2-.7z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.512
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: -45.82,
    cy: 80.197,
    r: 37.174,
    gradientTransform: "matrix(.526 0 0 -.223 130.969 97.429)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M87.2 83.9c35.1-12.4 29.2-12.4 35.2-16-11.2 4.3-32 4.7-39.4 16.7l4.2-.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: -32.429,
    y1: 73.095,
    x2: -32.293,
    y2: 66.244,
    gradientTransform: "matrix(.526 0 0 -.526 130.306 130.092)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.286,
    fill: "url(#j)",
    d: "M117.8 93.8c0 .8-2 1.4-4.6 1.4-2.5 0-4.6-.6-4.6-1.4 0-.8 2-1.4 4.6-1.4 2.6 0 4.6.6 4.6 1.4z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.621
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 112.548,
    y1: 76.804,
    x2: 112.548,
    y2: 71.974,
    gradientTransform: "matrix(.709 0 0 -1.134 33.501 178.262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M119.4 95.4c0 1.7-2.8 3-6.1 3-3.4 0-6.1-1.4-6.1-3 0-1.7 2.8-3 6.1-3 3.4 0 6.1 1.4 6.1 3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: -34.115,
    cy: 13.297,
    r: 15.297,
    gradientTransform: "matrix(.526 0 0 -.078 130.969 98.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M104.9 97.1c2.2 2 14.2 3 16.2-.6-3.9 2.8-12.5 1.8-16.2.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: -643.912,
    y1: 327.836,
    x2: -643.777,
    y2: 320.984,
    gradientTransform: "matrix(.203 -.103 -.238 -.469 311.261 190.221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.286,
    fill: "url(#m)",
    d: "M104.9 103.8c.4.9.2 1.9-.6 2.3-.8.4-1.8 0-2.2-.8-.4-.9-.2-1.9.6-2.3.8-.5 1.8-.1 2.2.8z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.621
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: -341.635,
    y1: 195.138,
    x2: -341.635,
    y2: 190.308,
    gradientTransform: "matrix(.273 -.139 -.513 -1.011 295.216 251.45)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M105.8 104.2c.7 1.3.3 2.8-.9 3.4-1.2.6-2.6 0-3.3-1.3-.7-1.3-.3-2.8.9-3.4 1.2-.6 2.6 0 3.3 1.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: -645.599,
    cy: 1737.484,
    r: 15.297,
    gradientTransform: "matrix(.203 -.103 -.035 -.069 297.352 162.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M101.9 107.8c1.7 1.4 8.3 1.5 5.8-2.4.7 3.1-3.8 2.8-5.8 2.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: -185.187,
    cy: 69.66,
    r: 24.692,
    gradientTransform: "matrix(.526 0 0 -.214 130.969 105.831)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M21 87.3c0-.3 22.4 6.8 26.2 10.7-3.1-3.1-19.1-10.1-21.5-10.2-2.4-.1-4.4-.3-4.7-.5z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.879 -.193 .234 .696 -20.21 36.726)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: -136.743,
    y1: 250.438,
    x2: -136.607,
    y2: 243.586,
    gradientTransform: "matrix(.463 .102 .123 -.366 65.856 208.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.286,
    fill: "url(#q)",
    d: "M38 105.3c0 .8-2 1.4-4.6 1.4s-4.6-.6-4.6-1.4c0-.8 2-1.4 4.6-1.4s4.6.6 4.6 1.4z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.621
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 60.343,
    y1: 183.942,
    x2: 60.343,
    y2: 179.112,
    gradientTransform: "matrix(.623 .219 .166 -.789 -34.636 234.581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M39.6 106.9c0 1.7-2.8 3-6.1 3s-6.1-1.4-6.1-3c0-1.7 2.8-3 6.1-3s6.1 1.3 6.1 3z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.616
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: -62.572,
    cy: 357.021,
    r: 11.363,
    gradientTransform: "matrix(.624 -.173 -.065 -.233 95.948 182.007)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M28.2 106.3s1.2 3.2 4.5 3.4c3.4.2 7.2-4 7.5-5.5-.6 1.3-3.8 5.2-7.9 5.1-2.4 0-4.1-3-4.1-3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 193.011,
    cy: 256.754,
    r: 59.425,
    gradientTransform: "matrix(1.712 0 0 -1.685 -261.607 451.789)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#t)",
    strokeWidth: 0.488,
    d: "M63.4 6.5c-3.4 0-6.7 1.2-9 3.6L9.7 55.9c-4.1 4.1-5.1 6.8-4.8 8.3.1.8.5 1.4 1.3 2.1.8.7 2 1.4 3.4 2 2.9 1.2 6.7 2.2 10.5 3.2s7.5 2.1 10.3 3.9c.4.3.8.6 1.1 1.1.3.5.4 1.1.3 1.7-.2 1.1-.9 1.7-1.6 2.2-1.4 1.1-3.3 1.9-5.2 2.8s-3.8 1.9-4.8 2.6c-.5.4-.7.7-.6.7 0 0-.1-.3.1-.1.6.6 2.5 1.7 4.9 2.6s5.3 1.9 8.2 2.8c2.9 1 5.9 1.9 8.4 2.9s4.6 1.9 5.9 3.3c.7.7 1.2 1.6 1.3 2.4.1.9-.1 1.7-.5 2.4-.7 1.4-1.8 2.5-2.7 3.5-1 1-1.9 2-2.2 2.7-.2.3-.2.5-.2.7 0 .1 0 .3.3.6 1.3 1.4 4.1 1.6 7.3 2.3 1.6.4 3.3.9 4.7 2.2s2.5 3.1 3 5.7c.2 1.1.8 1.6 2.1 2 1.4.4 3.5.5 5.8.2 4.6-.7 10.1-2.9 13.2-5.5l.2-.2c-.2-.2-.7-.5-1.5-.9-1-.5-2.1-.9-3-2-.4-.6-.7-1.4-.6-2.3.1-.9.6-1.6 1.2-2.2 5.2-5.2 10.2-6.5 14-7.5 1.9-.5 3.5-1 4.7-1.7 1.2-.8 2.2-1.8 3-3.8.1-.2.1-.3 0-.5-.1-.3-.4-.7-.9-1.1-1-.9-2.7-1.8-4.4-2.8-1.7-.9-3.3-1.8-4.5-2.9-.6-.6-1.2-1.2-1.3-2.3-.1-1.1.6-2 1.4-2.6 3-2.1 7.5-3.7 12.4-5.4 4.9-1.7 10.2-3.5 14.4-5.5 4.3-2 7.4-4.3 8.4-6.6.5-1.2.6-2.3.1-3.9s-1.7-3.4-3.9-5.5L72.7 10.2c-2.6-2.5-6-3.7-9.3-3.7zm49.8 86.9c-2.9.1-5.5 1.4-6.6 3.5.3.1.6.3 1.1.4 1.5.3 3.6.6 5.6.6s4.1-.1 5.4-.5c.5-.2.8-.3 1-.4-.3-1.2-.9-2-2.1-2.6-1.1-.8-2.8-1.1-4.4-1zm-76.5 9.8c-2.3-.2-5.1.7-6.5 1.9-.7.6-1 1.1-1 1.4 0 .3.1.8 1 1.6 1.5 1.3 3.1 1.1 5 .1 1.6-.9 3-2.5 3.9-4.2-.6-.4-1.4-.7-2.4-.8zm66.2.7c-.5.6-.7 1.2-.8 1.6 0 .6.1 1 .5 1.4.8.8 2.5 1.1 4.3.1 0-.2-.1-.5-.4-.9-.4-.8-1.7-1.7-3.6-2.2z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.325
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: -224.589,
    y1: 68.903,
    x2: -161.637,
    y2: 52.258,
    gradientTransform: "matrix(.485 0 0 -.485 149.184 125.791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M38.8 78.2c-2.7.8-11.4 4.1-10.2 6.6 1.2 2.4 21.5 3.4 24.6 10.6 1.4 3.1-3.1 5.5-2 8.7.9 2.5 7.6 8.7 11.9 11.7 3.4 2.3 7.8-1.9 6-5.3-2.8-5.5 9.9-12.2 15.6-15.3 3.3-1.8-6.9-10.6-6.9-10.6l-39-6.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 13.153,
    y1: 197.768,
    x2: 9.253,
    y2: 188.832,
    gradientTransform: "matrix(.88 0 0 -.88 42.035 252.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EEEEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M39.8 80.7c2.4 1.8 7.2.7 10.1 2 6.9 3.1 15.4 6.6 13.8.4L62 84.6v-2.8l-4.1 1s-3.2-2.5-4.6-3.4c-.3-.2-1.9 1.4-1.9 1.4l-.3-1.7c-2-.2-4-.3-5.8-.3-4.2.1-7 .7-5.5 1.9z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.478
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 26.356,
    cy: 55.589,
    r: 24.385,
    gradientTransform: "matrix(.656 0 0 -.834 66.991 147.128)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M85.1 86.3c-.9 3.4 11.5 8.1 10.5 10.5-2 5.2-13.2 1.7-21.8 12.6-1.2 1.6 1.7 7.2 1.3 6.5s-3.4-5.3-2.6-7.6c2.4-7.1 26-9.8 21.7-13.2-2.5-1.9-11.4-7.3-9.1-8.8z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.586,
    fill: "#fff",
    d: "M113 93.4c0 .3-.6.6-1.4.6-.8 0-1.4-.3-1.4-.6s.6-.6 1.4-.6c.8 0 1.4.3 1.4.6zM103.9 103.8c0 .3-.4.6-.9.6s-.9-.3-.9-.6.4-.6.9-.6.9.3.9.6zM35.2 103.3c0 .3-.7.6-1.5.6s-1.5-.3-1.5-.6.7-.6 1.5-.6 1.5.3 1.5.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: -245.694,
    y1: 88.661,
    x2: -235.88,
    y2: 80.864,
    gradientTransform: "matrix(.49 0 0 -.49 147.66 125.008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.251,
    fill: "url(#x)",
    d: "M34.3 78.5c-7.8 4.8-19.8 6.5-6.6 9.7-1.6-3.5 3.4-3.1 6.6-9.7z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.363
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: -115.448,
    y1: 55.254,
    x2: -144.875,
    y2: 134.487,
    gradientTransform: "matrix(.485 0 0 -.485 149.184 125.791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#729FCF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M61.9 122.2s12-1.1 14.7-4.6c1.6-2-6.4-4.4-4.7-6.4 6.5-7.4 12-7.1 19.6-10.3 7.6-3.1 4.8-4.6 2.3-6-4.2-2.3-13.6-4.8-10.5-10.4 3.1-5.6 30.4-13.4 30.4-13.4 8.3-2.8 7.2-7.9 3.2-12.2L92.6 34.8s1.2 23-3.7 32.9C82.8 79.8 50.5 93.4 64 94.9c4.8.5 7.1 2.2 9 5.8 4 7.6-11.1 21.5-11.1 21.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkscapeOriginal);
export default __webpack_public_path__ + "static/media/InkscapeOriginal.bcfbcf858762fbb7f4379402659d7fea.svg";
export { ForwardRef as ReactComponent };